module.exports = __webpack_public_path__ + "static/media/thermometer.56d7f6ff.png";